import { render, staticRenderFns } from "./RestaurantMenuSettingsCard.vue?vue&type=template&id=0035ac86"
import script from "./RestaurantMenuSettingsCard.vue?vue&type=script&lang=ts"
export * from "./RestaurantMenuSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports